// @flow

import { memo } from 'react';
import { trackViewItem } from '../../../../utils/googleAnalytics';

import type { TBandDetail } from '@types/band';

export default memo(
  function ViewItemEvent({ band }: { band: TBandDetail }) {
    trackViewItem(band);

    return null;
  },
  (prevProps, nextProps) =>
    prevProps.band.vendor_sku === nextProps.band.vendor_sku,
);
